var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "City",
    transform: "translate(8 58.249)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1302",
    "data-name": "Ellipse 1302",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(-8 -58.249)",
    fill: "#39be9d",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-city-1212374",
    transform: "translate(-81.869 -60.752)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34417",
    "data-name": "Path 34417",
    d: "M95.623,22.934h-.256V16.885A1.086,1.086,0,0,0,94.281,15.8H93.8v-.62a1.086,1.086,0,0,0-1.086-1.086H92v-.931h0A1.706,1.706,0,0,0,90.3,11.457H89.109V9.31a.465.465,0,0,0-.931,0v2.147h-1.45a1.706,1.706,0,0,0-1.706,1.706v3.469H83.471a1.706,1.706,0,0,0-1.706,1.706v4.6h-.1a.465.465,0,1,0,0,.931H95.623a.465.465,0,1,0,0-.931Zm-2.908-7.91h0a.155.155,0,0,1,.155.155v1.086a.465.465,0,0,0,.465.465h.946a.155.155,0,0,1,.155.155v6.049H92v-.853H93.11a.465.465,0,0,0,0-.931H92v-.62H93.11a.465.465,0,0,0,0-.931H92v-.62H93.11a.465.465,0,0,0,0-.931H92V15.024Zm-6.762-1.861h0a.775.775,0,0,1,.775-.775H90.3a.775.775,0,0,1,.775.775v9.771H85.952ZM82.7,18.34a.776.776,0,0,1,.775-.775h1.551v5.369H82.7Z",
    transform: "translate(0)",
    fill: "#39be9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34418",
    "data-name": "Path 34418",
    d: "M151.494,345.553h.569a.465.465,0,1,0,0-.931h-.569a.465.465,0,1,0,0,.931Z",
    transform: "translate(-67.896 -326.478)",
    fill: "#39be9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34419",
    "data-name": "Path 34419",
    d: "M152.066,400.62H151.5a.465.465,0,1,0,0,.931h.569a.465.465,0,1,0,0-.931Z",
    transform: "translate(-67.9 -380.925)",
    fill: "#39be9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34420",
    "data-name": "Path 34420",
    d: "M152.066,456.62H151.5a.465.465,0,1,0,0,.931h.569a.465.465,0,1,0,0-.931Z",
    transform: "translate(-67.9 -435.374)",
    fill: "#39be9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34421",
    "data-name": "Path 34421",
    d: "M273.748,182.515a.465.465,0,0,0,.465-.465v-.982a.465.465,0,0,0-.931,0v.982a.465.465,0,0,0,.465.465Z",
    transform: "translate(-186.765 -167.001)",
    fill: "#39be9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34422",
    "data-name": "Path 34422",
    d: "M329.748,182.515a.465.465,0,0,0,.465-.465v-.982a.465.465,0,0,0-.931,0v.982a.465.465,0,0,0,.465.465Z",
    transform: "translate(-241.214 -167.001)",
    fill: "#39be9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34423",
    "data-name": "Path 34423",
    d: "M385.748,182.515a.465.465,0,0,0,.465-.465v-.982a.465.465,0,0,0-.93,0v.982a.465.465,0,0,0,.465.465Z",
    transform: "translate(-295.663 -167.001)",
    fill: "#39be9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34424",
    "data-name": "Path 34424",
    d: "M273.748,294.515a.465.465,0,0,0,.465-.465v-.982a.465.465,0,1,0-.931,0v.982a.465.465,0,0,0,.465.465Z",
    transform: "translate(-186.765 -275.899)",
    fill: "#39be9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34425",
    "data-name": "Path 34425",
    d: "M329.748,294.515a.465.465,0,0,0,.465-.465v-.982a.465.465,0,1,0-.931,0v.982a.465.465,0,0,0,.465.465Z",
    transform: "translate(-241.214 -275.899)",
    fill: "#39be9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34426",
    "data-name": "Path 34426",
    d: "M385.748,294.515a.465.465,0,0,0,.465-.465v-.982a.465.465,0,1,0-.93,0v.982a.465.465,0,0,0,.465.465Z",
    transform: "translate(-295.663 -275.899)",
    fill: "#39be9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34427",
    "data-name": "Path 34427",
    d: "M273.748,406.515a.465.465,0,0,0,.465-.465v-.982a.465.465,0,0,0-.931,0v.982a.465.465,0,0,0,.465.465Z",
    transform: "translate(-186.765 -384.797)",
    fill: "#39be9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34428",
    "data-name": "Path 34428",
    d: "M329.748,406.515a.465.465,0,0,0,.465-.465v-.982a.465.465,0,0,0-.931,0v.982a.465.465,0,0,0,.465.465Z",
    transform: "translate(-241.214 -384.797)",
    fill: "#39be9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34429",
    "data-name": "Path 34429",
    d: "M385.748,406.515a.465.465,0,0,0,.465-.465v-.982a.465.465,0,0,0-.93,0v.982a.465.465,0,0,0,.465.465Z",
    transform: "translate(-295.663 -384.797)",
    fill: "#39be9d"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCity);
export default __webpack_public_path__ + "static/media/City.d6e4f809b08f8e81692af4fd8e2b8643.svg";
export { ForwardRef as ReactComponent };